Vue.http.headers.common['api-key'] = document.querySelector('meta[name=api_key]').getAttribute('content');

Vue.directive('date', {
    twoWay: true,
    bind: function () {
        var self = this;
        $(self.el).change(function() {
            var value = $(this).val();
            self.set(value);
        });
    },
    unbind: function () {
        var self = this;
    }
});

new Vue({

    el: '#suppliers',
    data: {
        api_url: document.querySelector('meta[name=api_url]').getAttribute('content'),

        filter: '',
        orderBy: 'name',
        sortBy: 'asc',

        view: 'index',

        // search model
        search: {
            keywords: ''
        },

        form: {
            name: '',
            email: '',
            phone: '',
            website: '',
            addr_1: '',
            addr_2: '',
            addr_3: '',
            addr_city: '',
            addr_county: '',
            addr_country: '',
            addr_postcode: '',
        },

        newContact: {
            firstname: '',
            surname: '',
            email: '',
            supplier_id: 0
        },

        suppliers: []
    },

    ready: function() {
        this.route();
        var self = this;
        window.onhashchange = function(e) {
            self.route();
        };
    },

    methods: {
        route: function() {
            this.$set('loading.view', true);

            var hash = (window.location.hash.substr(1)).split('/');

            // index
            if(! hash[0]) {
                this.view = 'index';
                this.getSuppliers();
                return;
            }

            // show
            if(hash.length === 1 && ! isNaN(hash[0])) {
                this.view = 'show';
                this.getSupplier(hash[0]);
                return;
            }

            // add
            if(hash.length === 1 && hash[0] == 'add') {
                this.loading.view = false;
                this.view = 'form';
                if(typeof this.errors !== 'undefined') {
                    this.errors.supplier = null;
                }
            }

            // edit
            if(hash.length === 2 && hash[1] == 'edit') {
                this.view = 'form';
                if(typeof this.errors !== 'undefined') {
                    this.errors.supplier = null;
                }
                if(this.suppliers.length) {
                    var supplier = this.suppliers.filter(function(supplier) {
                        return supplier.id == hash[0];
                    });

                    if(supplier.length) {
                        this.$set('form', supplier[0]);
                        this.$set('editing', JSON.parse(JSON.stringify(supplier[0])));
                    }

                    this.loading.view = false;
                }
                else {
                    this.$http.get(this.api_url+'/suppliers/'+hash[0], function(response) {
                        this.loading.view = false;
                        this.$set('form', response.supplier);
                        this.$set('editing', JSON.parse(JSON.stringify(response.supplier)));
                    }).error((data, status, response) => {
                        console.log(response);
                    });
                }
            }
        },

        // Add supplier contact
        addContact: function(e) {
            e.preventDefault();
            // validate
            var contact = this.newcontact;
            this.$http.post(this.api_url+'/contacts', contact, function(response) {
                this.contacts.push(response.contact);
                this.newcontact = { firstname: '', surname: '', email: '', role_id: 2, supplier_id: this.supplier.id }
                $('#addcontactform').modal('hide');
            }).error((data, status, response) => {
                if(status == 422) {
                     this.$set('errors.contact', data.errors);
                }
            });
        },

        showContactForm: function() {
            this.newcontact = {
                firstname: '',
                surname: '',
                email: '',
                supplier_id: this.supplier.id
            };
        },

        deleteContact: function(contact) {
            var conf = window.confirm('Are you sure you want to delete this supplier contact?');

            if(conf) {
                this.$http.delete(this.api_url+'/contacts/'+contact.id, function(response) {
                    this.contacts.$remove(contact);
                }).error((data, status, response) => {
                    console.log(response);
                });
            }
        },

        // Get suppliers
        getSuppliers: function() {
            this.$http.get(this.api_url+'/suppliers?per_page=10', function(response) {
                this.loading.view = false;
                this.$set('suppliers', response.suppliers);
                if(typeof response.pagination !== 'undefined') {
                    this.$set('pagination', response.pagination);
                }
            }).error((data, status, response) => {
                console.log(response);
            });
        },

        // Get a supplier
        getSupplier: function(id) {

            // Get supplier info
            this.$http.get(this.api_url+'/suppliers/'+id, function(response) {
                this.loading.view = false;
                this.$set('supplier', response.supplier);
                this.$set('venues', response.supplier.venues);
            }).error((data, status, response) => {
                console.log(response);
            });
        },

        // Delete a supplier
        deleteSupplier: function(supplier) {
            var conf = window.confirm('Are you sure you want to delete this supplier?');

            if(conf) {
                this.$http.delete(this.api_url+'/suppliers/'+supplier.id, function(response) {
                    this.suppliers.$remove(supplier);
                }).error((data, status, response) => {
                    console.log(response);
                });
            }
        },

        // Pagination
        page: function(dir) {
            this.loading.view = true; // show loading spinner

            if(dir === 'prev' || dir === 'next') {
                var url = dir === 'prev' ? this.pagination.prev_page_url : this.pagination.next_page_url;
            } else {
                var url = dir;
            }

            url += '&orderBy=' + this.orderBy + '&sortBy=' + this.sortBy;

            if(this.search.keywords) url += '&keywords='+this.search.keywords;

            this.$http.get(url, function(response) {
                this.loading.view = false;
                this.$set('suppliers', response.suppliers);
                if(typeof response.pagination !== 'undefined') {
                    this.$set('pagination', response.pagination);
                }
            }).error((data, status, response) => {
                console.log(response);
            });
        },

        // Sort
        sort: function(orderBy) {
            this.loading.view = true; // show loading spinner

            url = this.api_url+'/suppliers?per_page=10';

            if(this.search.keywords) url += '&keywords='+this.search.keywords;

            this.sortBy = (this.orderBy == orderBy) ? 'desc' : 'asc';
            this.orderBy = orderBy;

            url += '&orderBy=' + orderBy + '&sortBy=' + this.sortBy;

            this.$http.get(url, function(response) {
                this.loading.view = false;
                this.$set('suppliers', response.suppliers);
                if(typeof response.pagination !== 'undefined') {
                    this.$set('pagination', response.pagination);
                }
            }).error((data, status, response) => {
                console.log(response);
            });
        },

        // Search suppliers
        searchSuppliers: function(e) {
            e.preventDefault();

            this.loading.suppliers = true; // show loading spinner

            var url = this.api_url+'/suppliers?per_page=10';

            if(this.search.keywords) url += '&keywords='+this.search.keywords;

            this.$http.get(url, function(response) {
                this.loading.suppliers = false; // remove loading spinner
                this.suppliers = response.suppliers;
                if(typeof response.pagination !== 'undefined') {
                    this.pagination = response.pagination;
                }
            }).error((data, status, response) => {
                console.log(response);
            });
        },

        // Clear search
        clearSearch: function() {
            this.loading.suppliers = true; // show loading spinner

            this.$http.get(this.api_url+'/suppliers?per_page=10', function(response) {
                this.loading.suppliers = false; // remove loading spinner
                this.$set('suppliers', response.suppliers);
                this.search = {
                    location_id: 0,
                    keywords: ''
                };
                if(typeof response.pagination !== 'undefined') {
                    this.pagination = response.pagination;
                }
            }).error(function (data, status, request) {
                console.log(request);
            });
        },

        submitForm: function(e) {
            e.preventDefault();

            if(typeof this.editing !== 'undefined') {

                this.$http.put(this.api_url+'/suppliers/'+this.editing.id, this.form, function(response) {
                    this.form = {
                        name: '',
                        email: '',
                        phone: '',
                        addr_1: '',
                        addr_2: '',
                        addr_3: '',
                        addr_city: '',
                        addr_county: '',
                        addr_country: '',
                        addr_postcode: '',
                        description : '',
                        supplier_id: '',
                    };
                    this.getSuppliers();
                    this.loading.view = true;
                    this.view = 'index';
                    window.location = '#';
                }).error((data, status, response) => {
                    if(status == 422) {
                         this.$set('errors.supplier', data.errors);
                    }
                });
                return;
            }

            // add

            var formData = new FormData();
            formData.append('name', this.form.name);
            formData.append('email', this.form.email);
            formData.append('phone', this.form.phone);
            formData.append('addr_1', this.form.addr_1);
            formData.append('addr_2', this.form.addr_2);
            formData.append('addr_3', this.form.addr_3);
            formData.append('addr_city', this.form.addr_city);
            formData.append('addr_county', this.form.addr_county);
            formData.append('addr_country', this.form.addr_country);
            formData.append('addr_postcode', this.form.addr_postcode);
            formData.append('description', this.form.description);

            this.$http.post(this.api_url+'/suppliers', formData, function(response) {
                this.form = {
                    name: '',
                    email: '',
                    phone: '',
                    addr_1: '',
                    addr_2: '',
                    addr_3: '',
                    addr_city: '',
                    addr_county: '',
                    addr_country: '',
                    addr_postcode: '',
                    description : '',
                    supplier_id: '',
                };
                this.getSuppliers();
                this.loading.view = true;
                this.view = 'index';
                window.location = '#';
            }).error((data, status, response) => {
                if(status == 422) {
                     this.$set('errors.supplier', data.errors);
                }
            });
        }
    }
});
